export enum UserTypeEnum {
  EXTERNAL = 'EXTERNAL_B2B',
  INTERNAL = 'INTERNAL'
}
